import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPolicy } from "../../utils/backend";
import { CTabs, CTabList, CTabContent, CTab, CTabPanel } from "@coreui/react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import RenderPolicyDetails from "./RenderPolicyDetails";
import InsuredPersonalInfo from "./InsuredPersonalInfo";
import InsuranceDetails from "./InsuranceDetails";

const ViewPolicy = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [policy, setPolicy] = useState({});
  const { id } = useParams();

  useEffect(() => {
    fetchData(id);
  }, [id]);

  const hasPermission = (permissionGroup, permissionName) => {
  let permissions;
  try {
    permissions = JSON.parse(localStorage.getItem("permissions")) || [];
  } catch (error) {
    console.error("Error parsing permissions from localStorage:", error);
    permissions = [];
  }

  return permissions.some(
    (perm) =>
      perm.permission_group === permissionGroup &&
      perm.permission_name === permissionName
  );
};

  const fetchData = async (id) => {
    setIsLoading(true);
    try {
      const response = await getPolicy({ id: id });
      setPolicy(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setPolicy({});
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackClick = () => {
    navigate("/insurance-policies");
  };

  const isMotorInsurance = policy?.order_details?.insurance_type === 5;

  return (
    <>
      {isLoading ? (
        <div className="card border-light">
          <div className="card-body p-4">
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <Skeleton
                height={40}
                width={100}
                style={{ marginRight: "10px" }}
              />
              <Skeleton height={40} width={100} />
            </div>
          </div>
        </div>
      ) : (
        <div className="card border-light">
          <div className="card-body p-4">
            <CTabs activeItemKey="policy-details">
              <CTabList variant="underline">
                <CTab itemKey="policy-details">Policy Details</CTab>
                <CTab itemKey="insured-personal-information">
                  Insured's Personal Information
                </CTab>
                <CTab itemKey="insurance-details">Insurance Details</CTab>
              </CTabList>
              <CTabContent>
                <CTabPanel className="p-3" itemKey="policy-details">
                  <div className="card-body p-4">
                    <div className="row">
                      <RenderPolicyDetails data={policy} />
                    </div>
                  </div>
                </CTabPanel>
                <CTabPanel
                  className="p-3"
                  itemKey="insured-personal-information"
                >
                  <div className="card-body p-4">
                    <div className="row">
                      <InsuredPersonalInfo data={policy} />
                    </div>
                  </div>
                </CTabPanel>
                <CTabPanel className="p-3" itemKey="insurance-details">
                  <div className="card-body p-4">
                    <div className="row">
                      <InsuranceDetails data={policy} />
                    </div>
                  </div>
                </CTabPanel>
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn me-3 ansa-button-secondary"
                    onClick={handleBackClick}
                  >
                    Back
                  </button>
                  {hasPermission("Policy Management", "Edit") && !isMotorInsurance && (
                    <button
                      type="button"
                      className="btn ansa-button-primary"
                      onClick={() => navigate(`/insurance-policies/edit/${id}`)}
                    >
                      Edit
                    </button>
                  )}
                </div>
              </CTabContent>
            </CTabs>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewPolicy;
